export default "__VITE_ASSET__7a2132ab__"